import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type LevageMaterialItemData = {};

export const initialLevageMaterialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
